exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width: 991px) {\n#container-options[data-v-6efeb8b4] {\n    flex-direction: column-reverse;\n}\n#options[data-v-6efeb8b4] {\n    flex-direction: column !important;\n}\n.select-filter[data-v-6efeb8b4] {\n    margin-bottom: 1em;\n}\n}\n", ""]);

// exports
